'use strict';
import React from 'react';
import moment from 'moment';
import PropTypes from "prop-types";

const Date = (props) => {
    return <span>{props.value ? moment(props.value).format('DD-MM-YYYY') : "Niet gekend"}</span>;
};

Date.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
};

export default Date;